import axios from 'axios';

export default {
  getOrderData({ commit }, params) {
    commit('setLoading', true);
    commit('setError', '');

    return axios.get('/salesHead/getOrderData', { params })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },

  getCompanyData({ commit }, companyName) {
    commit('setLoading', true);

    return axios.get('/company', { params: { companyName } })
      .then(({ data }) => {
        commit('setCompanyData', data);
      })
      .catch(async () => {
        const { default: router } = await import('@/router/index.js');
        router.push({ name: 'Error404' });
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },

  setEmailText({ commit }) {
    commit('setEmailText');
  },

  finishRefund({ commit }, orderDetails) {
    commit('setLoading', true);
    commit('setError', '');

    return axios.post('/salesHead/return', orderDetails)
      .catch((err) => {
        commit('setError', err);
        throw err;
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};
